import React from 'react';
import { ClinicHeader } from '../../components/ClinicHeader';
import { ClinicHero } from '../../components/ClinicHero';
import { ClinicServices } from '../../components/ClinicServices';
import { ClinicDoctors } from '../../components/ClinicDoctors';
import { ClinicContact } from '../../components/ClinicContact';
import { ClinicFooter } from '../../components/ClinicFooter';
import '../../styles/clinic-landing.css';

export default function Home() {
  return (
    <div className="w-full bg-white clinic-home">
      <ClinicHeader />
      <ClinicHero />
      <ClinicServices />
      <ClinicDoctors />
      <ClinicContact />
      <ClinicFooter />
    </div>
  );
}
